import base64 from '../global/base64.js';
import md5 from 'js-md5'
import reqParm from '@/common/requset/reqParm.js';
import axios from 'axios'
import router from 'vue-router'
import global from '../global/global.js';

import timeHelper from '../global/timeHelper.js';

//提交到主服务器
const fSmApiReq = async (sReqUrl, sApiName, sMethodName, sReqJsonStr, sApiUserPhone, sApiUserId, sApiReqFrom,
  sApiRandomStr, sApiReqOrgAk, sApiReqOrgSk, checkSignType = 'MD5') => {
  let sReqTime = timeHelper.fGetNowTime(2);
  // 请求参数BASE64
  let sReqJsonBase64 = Base64.encode(sReqJsonStr);
  // 组装签名
  let sApiReqSign = sApiReqOrgSk + sReqJsonBase64 + sReqTime + sApiReqOrgSk;
  sApiReqSign = md5(sApiReqSign);
  sApiReqSign = sApiReqSign.toLowerCase();
  let js = {};
  // API名称
  js['API_NAME'] = sApiName;
  // 请求方法名
  js['METHOD_NAME'] = sMethodName;
  // 请求json BASE64字符串
  js['REQ_JSON_STR'] = sReqJsonBase64;
  // API用户手机号
  js['API_USER_PHONE'] = sApiUserPhone;
  // API用户ID
  js['API_USER_ID'] = sApiUserId || '1001';
  // 请求来源
  js['API_REQ_FROM'] = sApiReqFrom;
  // 请求TOKEN
  js['API_REQ_TOKEN'] = global.fGetPlatform().partnerInfo.token; //sessionStorage.getItem('token')
  // 请求随机字符串
  js['API_RANDOM_STR'] = sApiRandomStr;
  // 请求机构AK
  js['API_REQ_ORG_AK'] = sApiReqOrgAk;
  // 请求签名
  js['API_REQ_SIGN'] = sApiReqSign;
  // 请求时间
  js['API_REQ_TIME'] = sReqTime;
  js['API_REQ_VER'] = 'smPlatform';
  
  js['RANDOM_STR'] = sApiRandomStr;
  js['REQ_JSON'] = sReqJsonBase64;
  js['MCH_ID'] = sApiUserPhone;
  js['USER_ID'] = sApiUserId || '1001';
  js['REQ_IP'] = '127.0.0.1';
  js['REQ_FROM'] = sApiReqFrom;
  js['REQ_VER'] = 'smPlatform';
  js['REQ_TIME'] = sReqTime;
  js['REQ_TOKEN'] =  global.fGetPlatform().partnerInfo.token; //
  console.log(js)
  console.log(sReqUrl)
  let res = await axios.post(sReqUrl, js);
  // console.log(res)
  if (res.data.result != 'sucess' && res.data.msg == 'tokenFail') {
    window.location.replace('http://www.sanmipos.com/smsoft/partnerAdmin/#/login')
    return {
      data: {
        result: 'fail',
        msg: '请重新登录'
      }
    }
  }
  return res.data;
};
//smSell主服务器接口
const fPostToSmSellMainSrvApi = (sMethodName, reqJson = {}, post = '') => {
  let sReqUrl = 'https://www.91byk.com/smSellMain/api/smSellApi/';
  // global.fGetPlatform().partnerInfo.data.user_phone ||
  // global.fGetPlatform().partnerInfo.data.user_name ||
  let sApiUserPhone = global.fGetPlatform().partnerInfo.phone || '18957102098'
  let sApiUserId = '1001'
  console.log(sReqUrl)
  return fSmApiReq(sReqUrl, 'smSellMainSrvApi', sMethodName, JSON.stringify(reqJson),
    sApiUserPhone, sApiUserId, 'H5');
};


// 提交post到 zmCloudApi
const fZmCloudApiUrl = () => {
  let url = 'http://8.142.45.98:1880/zmCloudApi.asq';
  return url;
};
const fPostToZmCloudApi = async (params = {}) => {
  let res = await axios.post(fZmCloudApiUrl(), reqParm.fReqParam(params));
  return res;
};
// 提交post到 wxGzhApi
const fWxGzhApiUrl = () => {

  let url = 'http://8.142.45.98:1880/wxGzhApi.asq';
  return url;
};
const fPostToWxGzhApi = async (params = {}) => {
  params['PHONE_NO'] = global.fGetPlatform().partnerInfo.phone; // 合作伙伴手机号
  let res = await axios.post(fWxGzhApiUrl(), reqParm.fReqParam(params));
  return res;
};

// 提交post到 payInfoApi
const fPayInfoApiUrl = () => {
  let url = 'http://8.142.45.98:1880/payInfoApi.asq';
  return url;
};
const fPostToPayInfoApi = async (params = {}) => {
  let res = await axios.post(fPayInfoApiUrl(), reqParm.fReqParam(params));
  return res;
};

//提交post到 bykPlatFormApi 贝友客管理平台接口
const fBykPlatFormApiUrl = () => {
  let url = 'http://8.142.45.98:1880/bykPlatFormApi.asq';
  return url;
};
const fPostToBykPlatFormoApi = async (params = {}) => {
  params['PHONE_NO'] = global.fGetPlatform().partnerInfo.phone; // 合作伙伴手机号
  params['USER_ID'] = '1001';
  params['USER_TOKEN'] = global.fGetPlatform().partnerInfo.token;
  params['RANDOM_STR'] = '719ee78131675d5ed4cacbe41e1c8191'

  let res = await axios.post(fBykPlatFormApiUrl(), reqParm.fReqParam(params));

  if (res.data.result != 'sucess' && res.data.msg == 'tokenFail') {
    window.location.replace('/#/login')
    return {
      data: {
        result: 'fail',
        msg: '请重新登录'
      }
    }
  }
  return res;
};

//提交post到 byPayApi 贝友客管理平台接口
const fByPayApiUrl = (userIp) => {
  let url = 'http://' + userIp + ':1880/byPayApi.asq';
  return url;
};
const fPostToByPayApi = async (params = {}) => {
  let res = await axios.post(fByPayApiUrl(params['USER_SERVER_IP']), reqParm.fReqParam(params));
  return res;
};

// 提交post到 baiduApi 贝友客管理平台接口
const fByBaiDuApiUrl = (userIp) => {
  let url = 'http://' + userIp + ':1880/baiduApi.asq'; // http://8.142.45.98:1880/baiduApi.asq
  return url;
};
const fPostToBaiDuApi = async (params = {}) => {
  params['PHONE_NO'] = '18657189389'
  let res = await axios.post(fByBaiDuApiUrl('8.142.45.98'), reqParm.fReqParam(params));
  return res;
};


//smSell后台接口
const fPostToSmSellAdminApi = (sMethodName, reqJson = {}, url, ip, shPhone, sApiRandomStr) => {
  // store.state.smWgoSh.shLoadUrl
  let sReqUrl;
  if (window.location.protocol == "https:") {
    sReqUrl = url + '/api/smSellApi/';
  } else {
    sReqUrl = 'http://' + ip + ':5837/api/smSellApi/';
  }
  return fSmApiReq(sReqUrl, 'smSellAdminApi', sMethodName, JSON.stringify(reqJson),
    shPhone, '1001', 'WEB', sApiRandomStr);


};
const fPostToSmSellQueryApi = (sMethodName, reqJson = {}, url, ip, shPhone, sApiRandomStr) => {
  // store.state.smWgoSh.shLoadUrl
  let sReqUrl;
  if (window.location.protocol == "https:") {
    sReqUrl = url + '/api/smSellApi/';
  } else {
    sReqUrl = 'http://' + ip + ':5837/api/smSellApi/';
  }
  return fSmApiReq(sReqUrl, 'smSellQueryApi', sMethodName, JSON.stringify(reqJson),
    shPhone, '1001', 'WEB', sApiRandomStr);


};

const fPostToSmTakeOutTkAdminApi = (sMethodName, reqJson = {}, ip, shPhone, sApiRandomStr) => {
  // store.state.smWgoSh.shLoadUrl
  let sReqUrl;
  if (window.location.protocol == "https:") {
    sReqUrl = 'https://www.91byk.com/smSrvCaa/smTakeOut/tkAdmin';
  } else {
    sReqUrl = 'http://39.101.79.25/smTakeOut/tkAdmin';
  }
  // 'http://39.101.79.25/
  return fSmApiReq(sReqUrl, '', sMethodName, JSON.stringify(reqJson),
    global.fGetPlatform().partnerInfo.phone, '1001', 'WEB', sApiRandomStr);


};
const fPostToSmTakeOutTkQryApi = (sMethodName, reqJson = {}, ip, shPhone, sApiRandomStr) => {
  let sReqUrl;
  if (window.location.protocol == "https:") {
    sReqUrl = 'https://www.91byk.com/smSrvCaa/smTakeOut/tkQry';
  } else {
    sReqUrl = 'http://39.101.79.25/smTakeOut/tkQry';
  }
  return fSmApiReq(sReqUrl, '', sMethodName, JSON.stringify(reqJson),
    global.fGetPlatform().partnerInfo.phone, '1001', 'WEB', sApiRandomStr);


};

const fPostToSmDouYinDkAdminApi = (sMethodName, reqJson = {}, ip, shPhone, sApiRandomStr) => {
  let sReqUrl;
  if (window.location.protocol == "https:") {
    sReqUrl = 'https://www.91byk.com/smSrvCaa/smDouYin/dkAdmin';
  } else {
    sReqUrl = 'http://39.101.79.25/smDouYin/dkAdmin';
  }
  return fSmApiReq(sReqUrl, '', sMethodName, JSON.stringify(reqJson),
    global.fGetPlatform().partnerInfo.phone, '1001', 'WEB', sApiRandomStr);


};
const fPostToSmDouYinDkQryApi = (sMethodName, reqJson = {}, ip, shPhone, sApiRandomStr) => {
  let sReqUrl;
  if (window.location.protocol == "https:") {
    sReqUrl = 'https://www.91byk.com/smSrvCaa/smDouYin/dkQry';
  } else {
    sReqUrl = 'http://39.101.79.25/smDouYin/dkQry';
  }
  return fSmApiReq(sReqUrl, '', sMethodName, JSON.stringify(reqJson),
    global.fGetPlatform().partnerInfo.phone, '1001', 'WEB', sApiRandomStr);


};
const fPostToAdminApi = (sMethodName, reqJson = {}, ip, shPhone, sApiRandomStr) => {
  let sReqUrl;
  if (window.location.protocol == "https:") {
    sReqUrl = 'https://www.91byk.com/smSellMains/smSellMainAdmin/adminApi';
  } else {
    sReqUrl = 'http://8.142.45.98/smSellMainAdmin/adminApi';
  }
  return fSmApiReq(sReqUrl, '', sMethodName, JSON.stringify(reqJson),
    global.fGetPlatform().partnerInfo.phone, '1001', 'WEB', sApiRandomStr);


};

const fPostToQueryApi = (apiName, sMethodName, reqJson = {}, url,ip, shPhone, sApiRandomStr) => {
  let sReqUrl;
  if (window.location.protocol == "https:") {
    sReqUrl = url + 's/smSellQuery/queryApi'
  } else {
    sReqUrl = 'http://' + ip + '/smSellQuery/queryApi' //tkAdmin  tkQry
  }
  return fSmApiReq(sReqUrl, '', sMethodName, JSON.stringify(reqJson),
    shPhone, '1001', 'WEB', sApiRandomStr)
};
const fPostToNewAdminApi = (apiName, sMethodName, reqJson = {}, url,ip, shPhone, sApiRandomStr) => {
  let sReqUrl;
  if (window.location.protocol == "https:") {
    sReqUrl = url + 's/smSellAdmin/adminApi';
  } else {
    sReqUrl = 'http://' + ip + '/smSellAdmin/adminApi'; //tkAdmin  tkQry
  }
  return fSmApiReq(sReqUrl, '', sMethodName, JSON.stringify(reqJson),
    shPhone, '1001', 'WEB', sApiRandomStr)
};

export default {
  fPostToZmCloudApi, // 提交post到 zmCloudApi
  fPostToWxGzhApi, //提交post到 WxGzhApi
  fPostToBykPlatFormoApi, // 提交post到 bykPlatFormApi
  fPostToByPayApi, // 提交post到 byPayApi
  fPostToPayInfoApi, // 提交post到 payInfoApi
  fPostToBaiDuApi, // 提交post到 baiduApi
  fPostToSmSellMainSrvApi, //提交到主服务器
  fPostToSmSellAdminApi,
  fPostToSmSellQueryApi,
  fPostToSmTakeOutTkAdminApi,
  fPostToSmTakeOutTkQryApi,
  fPostToSmDouYinDkAdminApi,
  fPostToSmDouYinDkQryApi,
  fPostToAdminApi,
  fPostToNewAdminApi,
  fPostToQueryApi
}



// WEBPACK FOOTER //
// ./src/common/requset/postApi.js